module.exports = __webpack_public_path__ + "static/media/postgresql.b2da10a9.svg";